import Splitting from "splitting";

(function ($) {
  var w = window,
      $window = $(w),
      $document = $(document),
      $html = $('html'),
      $body = $('body'),
      $adminBar,
      adminBarVisibleHeight,
      scrollT,
      scrollUp = false,
      $triggerMobile = $('#menuTrigger'),
      sauvScroll = 0;

  function update_scroll() {
    // pas de changement du sens du scroll si on a scrollé de moins de 10px
    scrollUp = Math.abs( $window.scrollTop() - scrollT ) < 10 ? scrollUp : $window.scrollTop() <= scrollT;
    scrollT  = $window.scrollTop();
    $adminBar = $adminBar && $adminBar.length > 0 ? $adminBar : $('#wpadminbar');
    if ( $adminBar && $adminBar.length > 0 ) {
      adminBarVisibleHeight = Math.max( $adminBar.outerHeight() - scrollT + $adminBar.offset().top, 0 ) + 'px';
      document.documentElement.style.setProperty('--adminBarVisibleHeight',adminBarVisibleHeight);
    } else {
      document.documentElement.style.setProperty('--adminBarVisibleHeight',null);
    }
  }
  update_scroll();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Animation titre
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  let nbWords = 0;
  $('.pHeader_title span').each(function(index, el) {
    el.textContent = el.textContent.replace( '-', '- ' );
    const results = Splitting({ target: el, by: 'words' });
    $.each(results,function(i,result){
      $(result.words).each(function(){
        this.style.setProperty('--word-index',nbWords);
        nbWords++;
      });
    });
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Animation image accueil
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $.fn.visible = function(partial) {
    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
  
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
  };
  var $visibles = $( '.home_topHeader_img' );

  function update_visible() {
    $visibles.each(function(i, el) {
      var $el = $(el);
      if ($el.visible(true)) {
        $el.addClass("show"); 
      } 
    });
  }
  update_visible();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Accordéons
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function accs_init($cont) {
    $cont = $cont && $cont.length ? $cont : $body;
    $cont.find(".acc:not(.js-acc)").addClass("js-acc");
    accs_build($cont);
  }
  accs_init();

  function accs_build($cont) {
    $cont = $cont && $cont.length ? $cont : $body;
    $cont.find(".js-acc:not(.is-init)").each(function (idx, el) {
      acc_build(el);
    });
  }

  function acc_build(el, idAcc) {
    var $wrapper = $(el);
    var $head = $wrapper.children(":nth-last-child(2)");
    var $cont = $wrapper.children(":nth-child(2)");
    idAcc =
      idAcc ||
      Math.floor(Math.random() * (1000 + 1)) +
        1000 +
        "" +
        (Math.floor(Math.random() * (1000 + 1)) + 1000) +
        "" +
        (Math.floor(Math.random() * (1000 + 1)) + 1000) +
        "";

    $head
      .addClass("js-acc-head")
      .wrapInner(
        '<button type="button" aria-expanded="false" aria-controls="acc-id-' +
          idAcc +
          '" id="acc-title-id-' +
          idAcc +
          '"></button>'
      );
    $wrapper.addClass("is-init").addClass("is-closed");
    $cont
      .addClass("js-acc-content")
      .hide()
      .attr("id", "acc-id-" + idAcc)
      .attr("aria-labelledby", "acc-title-id-" + idAcc)
      .attr("aria-hidden", "true");
    $head.on("click", "button", function (event) {
      event.preventDefault();
      $cont.slideToggle(400);
      if ($wrapper.hasClass("is-closed")) {
        $wrapper.removeClass("is-closed");
        $head.find("[aria-expanded]").attr("aria-expanded", "true");
        $cont.attr("aria-hidden", "false");
      } else {
        $wrapper.addClass("is-closed");
        $head.find("[aria-expanded]").attr("aria-expanded", "false");
        $cont.attr("aria-hidden", "true");
      }
    });
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Réalisations
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  if ($('.real_i_img').length > 0) {
    $document.mousemove(function (e) {
      document.documentElement.style.setProperty('--cursorLeft',e.pageX+'px');
      document.documentElement.style.setProperty('--cursorTop',e.pageY+'px');
    });
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //News
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $('.news_open').on('click',function(){
    $('.news').addClass('news_visible');
    menu_mobile_close();
    return false;
  });
  $('.news_close').on('click',function(){
    $('.news').removeClass('news_visible');
    return false;
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu qui se masque
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function auto_hide_header() {
    if(!$html.hasClass('has-menuMobileOpen') && !scrollUp && scrollT > 10) {
      $html.addClass('is-nav-hide');
    } else {
      $html.removeClass('is-nav-hide');
    }
  }
  auto_hide_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var idMenuMobileTimeOut = false;
  $triggerMobile.on('click',function(e){
    e.preventDefault();
    menu_mobile_toggle();
  });

  function menu_mobile_toggle() {
    if($html.hasClass('has-menuMobileOpen')) {
      menu_mobile_close();
    } else {
      menu_mobile_open();
    }
  }
  
  function menu_mobile_open() {
    if(!$html.hasClass('is-scrollBlockedMobile')) {
      sauvScroll = scrollT;
      w.scrollTo(0, 0);
      idMenuMobileTimeOut = w.setTimeout(function() {
        $html.addClass('is-scrollBlockedMobile');
      }, 300);
    }
    $html.addClass('has-menuMobileOpen');
    if ( $body.hasClass( 'bg-blue' ) ) {
      $('meta[name="theme-color"]').attr('content','#ffffff');
    }
  }
  
  function menu_mobile_close() {
    if(idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
    $html.removeClass('is-scrollBlockedMobile');
    // closeSubMenu();
    w.scrollTo(0, sauvScroll);
    w.setTimeout(function() {
      $html.removeClass('has-menuMobileOpen');
    }, 50);
    if ( $body.hasClass( 'bg-blue' ) ) {
      $('meta[name="theme-color"]').attr('content','#10069f');
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window.on('scroll', function() {
    update_scroll();
    auto_hide_header();
    update_visible();
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window.on('resize', function() {
    $window.trigger('scroll');
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On load
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $document.on('load', function() {
    $window.trigger('scroll');
  });

})(jQuery);
